/* eslint-disable @typescript-eslint/no-unnecessary-condition -- Wrong typing, ownerState cen be null */
import { alpha } from '@mui/system';
import { CheckCircle, Clock, ErrorCircle, InfoCircle } from '@ori-ui/icons';
import { colors } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const styleOverrides = {
  root: ({
    ownerState
  }) => ({
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: '1fr auto 1fr',
    opacity: 0.85,
    '& a': {
      fontWeight: 'bold'
    },
    '& a:hover': {
      color: colors.oriGrey[300]
    },
    ...(ownerState?.color === 'default' && ownerState?.variant === 'filled' && {
      backgroundColor: alpha(colors.commonColors.black, 0.6),
      color: colors.commonColors.white
    }),
    ...((ownerState?.severity === 'success' || ownerState?.color === 'success') && ownerState?.variant === 'filled' && {
      color: colors.commonColors.white
    })
  }),
  standard: {
    display: 'block',
    opacity: 1,
    position: 'relative',
    padding: 0,
    fontWeight: 'normal',
    '& .MuiAlert-action': {
      position: 'absolute',
      top: '2px',
      right: '2px',
      padding: 0,
      margin: 0
    }
  },
  standardInfo: ({
    ownerState
  }) => ({
    backgroundColor: alpha(colors.info.light, 0.1),
    color: colors.info.main,
    borderColor: colors.info.main,
    ...(ownerState?.color === 'info' && {
      backgroundColor: alpha(colors.defaultColors.light, 0.1),
      color: colors.defaultColors.main,
      borderColor: colors.defaultColors.main
    })
  }),
  standardError: {
    backgroundColor: alpha(colors.error.main, 0.1),
    color: colors.error.dark,
    borderColor: colors.error.dark
  },
  standardSuccess: {
    backgroundColor: alpha(colors.success.main, 0.1),
    color: colors.success.dark,
    borderColor: colors.success.dark
  },
  standardWarning: {
    backgroundColor: alpha(colors.warning.main, 0.1),
    color: colors.text.secondary,
    borderColor: 'transparent'
  },
  icon: ({
    ownerState
  }) => ({
    justifySelf: 'end',
    marginTop: -3,
    marginBottom: -3,
    '& .MuiSvgIcon-root': {
      fontSize: 28
    },
    ...(ownerState?.variant === 'standard' && {
      display: 'none'
    })
  }),
  message: ({
    ownerState
  }) => ({
    justifySelf: 'center',
    ...(ownerState?.variant === 'standard' && {
      maxWidth: '600px',
      margin: '0 auto',
      padding: '20px'
    })
  }),
  action: ({
    ownerState
  }) => ({
    marginLeft: 0,
    justifySelf: 'end'
  })
};
const defaultProps = {
  variant: 'filled',
  iconMapping: {
    error: /*#__PURE__*/_jsx(ErrorCircle, {}),
    info: /*#__PURE__*/_jsx(InfoCircle, {}),
    success: /*#__PURE__*/_jsx(CheckCircle, {}),
    warning: /*#__PURE__*/_jsx(Clock, {})
  }
};
export default {
  defaultProps,
  styleOverrides
};
//# sourceMappingURL=MuiAlert.js.map